import React, { useCallback, useState } from 'react'
import { components } from 'react-select'
import classnames from 'classnames'

import Chip from '../../Chip'

import useStyles from './styles'

export default function Option(props) {
  const {
    chip,
    chipColor,
    tag,
    description,
    label,
    icon: Icon,
    img,
    withUnderline,
    className,
    pseudoDisabled,
    isDisabled
  } = props.data

  const classes = useStyles({ withUnderline, pseudoDisabled })

  const [imageUrlFailed, setImageUrlFailed] = useState(false)

  const handleImageError = useCallback(() => {
    setImageUrlFailed(true)
  }, [])

  const handleImageLoad = useCallback(() => {
    setImageUrlFailed(false)
  }, [])

  return (
    <components.Option
      {...props}
      className={classnames(classes.option, className, {
        [classes.pseudoDisabled]: pseudoDisabled,
        [classes.disabled]: isDisabled
      })}
    >
      <div className={classes.optionInnerContainer}>
        {Icon && (
          <section className={classes.iconContainer}>
            <Icon />
          </section>
        )}
        {img && (
          <div className={classes.iconContainer} style={{ display: imageUrlFailed ? 'none' : 'flex' }}>
            <img src={img} alt="icon" onError={handleImageError} onLoad={handleImageLoad} />
          </div>
        )}
        <div>
          <div className={classes.label}>{label}</div>
          {description && <div className={classes.description}>{description}</div>}
        </div>
        {tag && <div className={classes.tag}>{tag}</div>}
        {chip && (
          <div className={classes.chip}>
            <Chip text={chip} color={chipColor} />
          </div>
        )}
      </div>
    </components.Option>
  )
}
